export default __webpack_public_path__ + "images/logo-full.2c1f17015e5832ec04d45d2f52bc4356.png";